// extracted by mini-css-extract-plugin
export var legendIndicator = "_ct-1";
export var legendRight = "_ct-0";